module.exports = __webpack_public_path__ + "media/fr_fr_s3_Lisette.2f84df0d.oga";